<template>
  <v-app class="tw-relative">
    <div class="fox-loading-spinner">
      <v-progress-circular v-show="loading"
                           indeterminate
                           :size="70"
                           :width="7"
                           color="primary"
      ></v-progress-circular>
    </div>
    <OfferForm @invoiceExample="invoiceExample" @preview="previewInvoice" @downloadPdf="downloadPdf" />
    <SendAsEmail @submit="submitDownload" :show-snack="showSnack" :showCapture="showCapture"
                 :loading-capture="loadingCapture" @update:showCapture="showCapture = $event" />
    <SidebarImage/>
  </v-app>
</template>

<script>

import OfferForm from '@/components/Offer/OfferForm'
import InvoiceService from '@/services/invoice.service'
import DocumentService from '@/services/document.service'

import UserService from '@/services/user.service'
import SendAsEmail from '@/components/Common/SendAsEmail/SendAsEmail'
import SidebarImage from '@/components/SideBar/SidebarImage.vue'

const VUE_APP_BACKEND_API_URL = process.env.VUE_APP_BACKEND_API_URL

export default {
  name: 'OfferCreate',
  components: { SendAsEmail, OfferForm, SidebarImage },
  data: function () {
    return {
      loading: false,
      showCapture: false,
      documentUuid: null,
      loadingCapture: false,
      showSnack: false
    }
  },
  mounted () {
    window._tfa = window._tfa || []
    window._tfa.push({ notify: 'event', name: 'page_view', id: 1455597 })
  },
  methods: {
    async invoiceExample () {
      window.open(`${VUE_APP_BACKEND_API_URL}/pdf/examples/invoice.pdf`)
    },
    async previewInvoice (invoice) {
      this.loading = true
      const invoiceDocumentUuid = await InvoiceService.createInvoice(invoice)
      this.loading = false

      const route = this.$router.resolve({ name: 'DocumentPreview', params: { documentUuid: invoiceDocumentUuid } })
      window.open(route.href)
    },
    async downloadPdf (invoice) {
      this.loading = true
      this.documentUuid = await InvoiceService.createInvoice(invoice)
      this.loading = false
      this.showCapture = true
    },
    async submitDownload ({ email, newsletterConsent }) {
      this.loadingCapture = true
      this.showCapture = true
      const response = await DocumentService.sendAsMail(this.documentUuid, email, this.$router)
      this.loadingCapture = false
      this.trackInvoiceDownload()
      this.showCapture = false
      if (response?.data?.downloadUrl) {
        this.triggerDownload(response.data.downloadUrl)
      }
      if (newsletterConsent) {
        await UserService.createConsent(this.documentUuid)
      }
    },
    triggerDownload (url) {
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.download = ''
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    trackInvoiceDownload () {
      window.dataLayer.push({ event: 'invoice_download_gtm' })
    }
  }
}
</script>
